/* global System */

export default {
  CtaDivider: () =>
    System.import(/* webpackChunkName: "CtaDivider" */ './index'),
}
